define('constants/attachmentFileTypesConstants',[], function() {
    return {
        video : "video",
        image : "image",
        audio : "audio"
    };
});
